<template lang="pug">
  .settings
      v-container.white.pa-0(style="max-width:600px")

        v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mt-5'")
          //- User setting
          .payment_options
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/user-access')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="person-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('payment_options') }}
                  .c1.basic600--text {{ $t('payment_options_description') }}
            v-divider.basic300
          //- Assign Table
          .assign_table
            v-row.pa-4(no-gutters align="center" @click="$router.push('/admin/restaurant/assign-table')" style="cursor: pointer")
              v-col.shrink()
                v-icon.ma-auto(color="basic700") $yzi-qr-code-02
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('generate_qr_code') }}
                  .c1.basic600--text {{ $t('generate_qr_code_description') }}
            v-divider.basic300

</template>

<script>
import { mapState } from 'vuex'
import DeleteCompany from '@/components/dialogs/settings/DeleteCompany.vue'

export default {
  name: 'TableOrdering',
  components: { DeleteCompany },
  props: ['company'],
  data () {
    return {
      showSubscribeModal: false,
      deleteCompanyDialog: false,
    }
  },
  computed: {
    ...mapState('user', ['member'])
  }
}
</script>
